<template>
  <div ref="Notifications" class="LmNotifications">
    <div v-show="show" class="fixed top inset-0" @click="close" />
    <lm-icon-button
      class="NotificationIcon"
      :class="{'is-new': notifications}"
      icon="notifications"
      svg
      bg-black
      tooltip="Notifications"
      @click="toggle"
    />
    <ul
      v-show="show"
      ref="NotificationList"
      class="NotificationList z-dropdown min-w-80 max-h-screen-margin overflow-auto bg-white border shadow-md"
    >
      <header class="flex items-center justify-between px-4 py-3 border-b">
        <h1 class="font-mono uppercase tracking-widest text-xxs text-gray-700">
          Notifications
        </h1>
        <lm-modal-button
          title="Dismiss All"
          :disabled="mentions.length === 0"
          @click="dismissAll"
        />
      </header>
      <li v-if="mentions.length === 0" class="px-4 py-5 text-gray-700">
        No new notifications to show.
      </li>
      <mention-item
        v-for="mention in mentions"
        :key="mention.key"
        :mention="mention"
      />
    </ul>
  </div>
</template>

<script>
import LmModalButton from '@/components/ui/button/LmModalButton'
import LmIconButton from '@/components/ui/LmIconButton'
import MentionItem from '@/components/ui/mention/MentionItem'
import {mapGetters} from 'vuex'
import Popper from 'popper.js'

export default {
  name: 'LmNotifications',
  components: {LmModalButton, MentionItem, LmIconButton},
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['unreadMentions', 'mentions']),
    notifications() {
      return this.unreadMentions
    }
  },
  mounted() {
    this.popper = new Popper(
      this.$refs.Notifications,
      this.$refs.NotificationList,
      {
        placement: 'top-end',
        modifiers: {
          offset: {offset: '0, 5'},
          preventOverflow: {
            priority: ['left']
          }
        }
      }
    )
  },
  beforeDestroy() {
    if (this.popper) this.popper.destroy()
  },
  methods: {
    async toggle() {
      if (this.show) this.close()
      else {
        this.show = true
        await this.$nextTick()
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (this.show) {
        this.$store.dispatch('readAllMentions')
        this.show = false
      }
    },
    dismissAll() {
      if (this.mentions.length > 0) {
        this.$store.dispatch('dismissAllMentions')
      }
    }
  }
}
</script>

<style scoped>
.NotificationIcon.is-new {
  position: relative;
}
.NotificationIcon.is-new:before {
  content: '';
  position: absolute;
  top: -4px;
  left: -6px;
  width: 15px;
  height: 15px;
  background-color: theme('colors.highlight');
  border: 4px solid theme('colors.gray.900');
  border-radius: 100%;
  animation: blink 0.6s 4;
}
.NotificationList:last-child {
  border: none;
}
@media (min-width: 450px) {
  .NotificationList {
    width: 420px;
  }
}
</style>
